import { Component, Input, OnInit } from '@angular/core';
import { WindowRefService } from '../../services/window-ref/window-ref.service';
import { Router } from '@angular/router';

const SYNAPPS_ICON = [
    'brand-runiso',
    'brand-claranet',
    'physical-server',
    'virtual-server',
    'workstation',
    'brand-debian',
    'brand-centos',
    'brand-redhat',
    'brand-ubuntu',
    'brand-windows'
];

@Component({
    selector: 'syn-avatar',
    templateUrl: 'avatar.component.html',
    styleUrls: ['avatar.component.scss']
})
export class AvatarComponent implements OnInit {
    @Input() size = 32;
    @Input() backgroundColor = 'transparent';
    @Input() iconColor = 'var(--clara-black)';
    @Input() maxWidth;
    @Input() tooltip = '';
    @Input() tooltipPosition = 'left';
    @Input() wrap = false;

    @Input() link: string;
    @Input() externalLink: string;
    @Input() targetBlank = true;

    @Input() avatarIco: string;
    @Input() matIco: string;
    @Input() initials = '?';

    @Input() text: string;
    @Input() caption: string;
    @Input() textColor = 'var(--clara-black)';
    @Input() muted = false;
    @Input() iconSize: number;
    public useMatIco = false;
    public useSynIco = false;
    public useInitials = false;
    public usePicture = false;

    public iconStyle: object;

    constructor(
        private winRef: WindowRefService,
        private router: Router
    ) { }

    ngOnInit() {
        // when you pass an input undefined Angular not set default value
        if (!this.backgroundColor) {
            this.backgroundColor = 'transparent';
        }
        if (!this.iconColor) {
            this.iconColor = 'var(--clara-black)';
        }
        if (!this.tooltipPosition) {
            this.tooltipPosition = 'left';
        }
        // Select chip type
        if (this.avatarIco) {
            this.usePicture = true;
        } else if (SYNAPPS_ICON.includes(this.matIco)) {
            this.useSynIco = true;
        } else if (this.matIco) {
            this.useMatIco = true;
        } else {
            this.initials = this.initials.substr(0, 2);
            this.useInitials = true;
        }

        if (this.iconSize) {
            const size = this.iconSize + 'px';
            this.iconStyle = {
                fontSize: size,
                height: size,
                width: size
            };
        }
    }

    goToLink(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (this.externalLink) {
            return this.winRef.nativeWindow.open(this.externalLink, this.targetBlank && '_blank' || '_self');
        }
        return this.router.navigate([this.link]);
    }
}
